/**
 * Role rules shared by the admin screens.
 *
 * `admin` is a wildcard for section access, so section roles
 * (Depletions, Marketing, …) are redundant next to it and hidden. These
 * roles are not implied by admin and stay visible and grantable beside it:
 *
 *  - `field_rep` carries data ownership (territory, home address, the rep
 *    who owns a visit note), which an admin who also works the field
 *    needs explicitly.
 *  - `data_upload` is deliberately separate: loading depletion files
 *    changes DEV and PROD data, so the API checks it with
 *    require_explicit_role and admin alone doesn't pass.
 */
export const ROLES_ALONGSIDE_ADMIN: ReadonlySet<string> = new Set(['field_rep', 'data_upload']);
